import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { Moment } from 'moment';

@Pipe({ name: 'certificationExpirationColor' })
export class CertificateExpirationColorPipe implements PipeTransform {
    transform(expirationDate: Moment): string {
        const today = moment().startOf('day');

        const duration = moment.duration(today.diff(expirationDate));
        const durationInMonths = duration.asMonths();

        const red = '#B9493D';
        const orange = '#EF9D1A';

        if (durationInMonths < 3 && durationInMonths > 0) {
            return red;
        } else if (durationInMonths <= 0 && durationInMonths >= -3) {
            return orange;
        }
    }
}
